import { NgClass } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { SectionType } from '@app/models/section-type';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [NgClass],
})
export class HeaderComponent {
  public navbarExpanded = false;
  public readonly SectionType = SectionType;

  public readonly lotteryEnded = input.required<boolean>();
  public readonly navigationClick = output<SectionType>();

  public onClick(sectionType: SectionType): void {
    this.onNavbarToggle();
    this.navigationClick.emit(sectionType);
  }

  public onNavbarToggle(): void {
    this.navbarExpanded = !this.navbarExpanded;
  }
}
